export default __webpack_public_path__ + "static/media/beapartwavetop.6add8de3.png";